module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_heby-203765ae3c7e51bb6ab212b8c0c6f5eb.png";